export default {
    namespaced: true,

    state: {
        member: {},
    },

    mutations: {
        setTeamMember(state, data) {
            state.member = data;
        },

        updateTeamMemberStatus(state, status) {
            state.member.status = status;
        },

        reset(state) {
            state.member = {};
        },

        logOut(state) {
            state.member = {};
        },
    },
};
